import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../profile/styles.css';

export default function ProfileArtistHelpArtworksPage() {
  const t = useTranslations('artist_help.artworks');
  const [openSections, setOpenSections] = useState({
    editUpload: false,
    collectorsClaim: false,
    royalties: false,
    removedArtworks: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('editUpload')}
            aria-expanded={openSections.editUpload}
          >
            <h2>{t('sections.edit_upload.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.editUpload ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.editUpload && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.edit_upload.intro_p1')}</p>
              <p>{t('sections.edit_upload.intro_p2')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.edit_upload.how_it_works_title')}</h3>
                <ul>
                  <li>{t('sections.edit_upload.how_it_works_list_1')}</li>
                  <li>{t('sections.edit_upload.how_it_works_list_2')}</li>
                  <li>{t('sections.edit_upload.how_it_works_list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.edit_upload.what_it_means_title')}</h3>
                <ul>
                  <li>{t('sections.edit_upload.what_it_means_list_1')}</li>
                  <li>{t('sections.edit_upload.what_it_means_list_2')}</li>
                  <li>{t('sections.edit_upload.what_it_means_list_3')}</li>
                  <li>{t('sections.edit_upload.what_it_means_list_4')}</li>
                </ul>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('collectorsClaim')}
            aria-expanded={openSections.collectorsClaim}
          >
            <h2>{t('sections.collectors_claim.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.collectorsClaim ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.collectorsClaim && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.collectors_claim.intro_p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.collectors_claim.why_matters_title')}</h3>
                <ul>
                  <li>{t('sections.collectors_claim.why_matters_list_1')}</li>
                  <li>{t('sections.collectors_claim.why_matters_list_2')}</li>
                  <li>{t('sections.collectors_claim.why_matters_list_3')}</li>
                  <li>{t('sections.collectors_claim.why_matters_list_4')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.collectors_claim.pre_suarte_sale_title')}</h3>
                <p>{t('sections.collectors_claim.pre_suarte_sale_p1')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.collectors_claim.benefits_everyone_title')}</h3>
                <ul>
                  <li>{t('sections.collectors_claim.benefits_everyone_list_1')}</li>
                  <li>{t('sections.collectors_claim.benefits_everyone_list_2')}</li>
                </ul>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.collectors_claim.note_title')}</h3>
                <p>{t('sections.collectors_claim.note_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('royalties')}
            aria-expanded={openSections.royalties}
          >
            <h2>{t('sections.royalties.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.royalties ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.royalties && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.royalties.intro_p1')}</p>
              <ul>
                <li>{t('sections.royalties.list_1')}</li>
                <li>{t('sections.royalties.list_2')}</li>
              </ul>

              <div className="artist-help-category__stack">
                <h3>{t('sections.royalties.example_title')}</h3>
                <p>{t('sections.royalties.example_p1')}</p>
                <p>{t('sections.royalties.example_p2')}</p>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.royalties.tip_title')}</h3>
                <p>{t('sections.royalties.tip_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('removedArtworks')}
            aria-expanded={openSections.removedArtworks}
          >
            <h2>{t('sections.removed_artworks.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.removedArtworks ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.removedArtworks && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.removed_artworks.intro_p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.removed_artworks.what_expect_title')}</h3>
                <ul>
                  <li>{t('sections.removed_artworks.what_expect_list_1')}</li>
                  <li>{t('sections.removed_artworks.what_expect_list_2')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.removed_artworks.features_remain_title')}</h3>
                <p>{t('sections.removed_artworks.features_remain_p1')}</p>
                <ul>
                  <li>{t('sections.removed_artworks.features_remain_list_1')}</li>
                  <li>{t('sections.removed_artworks.features_remain_list_2')}</li>
                  <li>{t('sections.removed_artworks.features_remain_list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.removed_artworks.new_gallery_title')}</h3>
                <p>{t('sections.removed_artworks.new_gallery_p1')}</p>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.removed_artworks.in_short_title')}</h3>
                <p>{t('sections.removed_artworks.in_short_p1')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
